import { render } from "./LogoDark.vue?vue&type=template&id=76ac04fa&scoped=true"
import script from "./LogoDark.vue?vue&type=script&lang=js"
export * from "./LogoDark.vue?vue&type=script&lang=js"

import "./LogoDark.vue?vue&type=style&index=0&id=76ac04fa&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ac04fa"]])

export default __exports__